import useFabricContext from '../providers/hooks/useFabricContext';
import useOptionContext from '../providers/hooks/useOptionContext';
import useUserContext from '../providers/hooks/useUserContext';
import type { typeOptionValue } from '../utils/interfaces';
import { calculateTotalPrice } from '../utils/totalPrice';

export const useTotalPrice = (optionValues: typeOptionValue) => {
  const { product } = useUserContext();
  const { selectedFabric } = useFabricContext();
  const { selectedOptions, hiddenOptionsAndValues, isAdditionalProductAdded } = useOptionContext();

  return calculateTotalPrice({
    product,
    selectedFabric,
    selectedOptions,
    hiddenOptionsAndValues,
    optionValues,
    isAdditionalProductAdded,
  });
};
